/// When adding a tracking key, make sure you add it to the Tracking on Notion
/// https://www.notion.so/raisework/Segment-Analytics-210b3dbd296146c58e5135c083ad588d

export var TrackingEventNames = /*#__PURE__*/function (TrackingEventNames) {
  // General Deprecated
  TrackingEventNames["ADD_LISTING_TO_DEALROOM"] = "add_listings_to_dealroom";
  TrackingEventNames["APPLY_FILTERS"] = "apply_filters";
  TrackingEventNames["OPEN_FILTERS_MODAL"] = "open_filters_modal";
  TrackingEventNames["TOGGLE_MAP"] = "toggle_map";
  // New Tracking Constants:
  TrackingEventNames["ELEMENT_PRESSED"] = "element pressed";
  return TrackingEventNames;
}({});

// Make sure these are in alphabetical order

export var TrackingEventPageView = /*#__PURE__*/function (TrackingEventPageView) {
  TrackingEventPageView["BROKER_DEALROOM_NEW_DEAL"] = "broker dealroom new deal";
  TrackingEventPageView["BROKER_DEALROOM_OVERVIEW"] = "broker dealroom overview";
  TrackingEventPageView["CLIENT_DEALROOM_LISTINGS"] = "client dealroom listings";
  TrackingEventPageView["CLIENT_DEALROOM_OVERVIEW"] = "client dealroom overview";
  TrackingEventPageView["CLIENT_DEALROOM_PROPOSALS"] = "client dealroom proposals";
  TrackingEventPageView["CLIENT_DEALROOM_TOURS"] = "client dealroom tours";
  TrackingEventPageView["PORTFOLIO_MANAGEMENT_ACTIVE_LEASES"] = "portfolio management active leases";
  TrackingEventPageView["PORTFOLIO_MANAGEMENT_CRITICAL_DATES"] = "portfolio management critical dates";
  TrackingEventPageView["PORTFOLIO_MANAGEMENT_DOCUMENTS"] = "portfolio management documents";
  TrackingEventPageView["PORTFOLIO_MANAGEMENT_LEASE_DETAILS"] = "portfolio management lease details";
  TrackingEventPageView["PORTFOLIO_MANAGEMENT_OVERVIEW"] = "portfolio managment overview";
  TrackingEventPageView["PORTFOLIO_MANAGEMENT_RENT_SCHEDULE"] = "portfolio management rent schedule";
  return TrackingEventPageView;
}({});

// Make sure these are in alphabetical order
export var TrackingEventContext = /*#__PURE__*/function (TrackingEventContext) {
  TrackingEventContext["ADD_CLIENT_CONTACT"] = "add client contact";
  TrackingEventContext["ADD_NOTE"] = "add note";
  TrackingEventContext["ADD_OUTREACH"] = "add outreach";
  TrackingEventContext["ADD_REMINDER"] = "add reminder";
  TrackingEventContext["ADD_TO_CALENDAR"] = "add to calendar";
  TrackingEventContext["ADD_OCCUPANCY"] = "add occupancy";
  TrackingEventContext["BACK_TO_LISTINGS"] = "back to listings";
  TrackingEventContext["CAROUSEL_ARROWS"] = "carousel arrows";
  TrackingEventContext["CATEGORY_PILL"] = "category pill";
  TrackingEventContext["CLONE_DEALROOM"] = "clone dealroom";
  TrackingEventContext["COMMENTED_ON_LISTING"] = "commented on listing";
  TrackingEventContext["COMPARE_BUTTON"] = "compare button";
  TrackingEventContext["COMPARED_LISTINGS"] = "compared listings";
  TrackingEventContext["DEFAULT_BROKER"] = "default broker";
  TrackingEventContext["COPY_LINK"] = "copy link";
  TrackingEventContext["CREATE_NOTE"] = "create note";
  TrackingEventContext["CREATE_OUTREACH"] = "create outreach";
  TrackingEventContext["CREATE_REMINDER"] = "create reminder";
  TrackingEventContext["CRITICAL_DATE_EVENT"] = "critical date event";
  TrackingEventContext["DEAL_PHASE_UPDATE"] = "deal phase update";
  TrackingEventContext["DEALROOM_VISIBLE"] = "dealroom visible";
  TrackingEventContext["DELETE_DOCUMENT"] = "delete document";
  TrackingEventContext["DELETE_FOLDER"] = "delete folder";
  TrackingEventContext["DISLIKED_LISTING"] = "disliked listing";
  TrackingEventContext["DOCUMENT_ADDED_COMMENT"] = "document added comment";
  TrackingEventContext["DOCUMENT_FILE_NAME"] = "document file name";
  TrackingEventContext["DOWNLOAD_DOCUMENT"] = "download document";
  TrackingEventContext["EDIT_CLIENT_CONTACT"] = "edit client contact";
  TrackingEventContext["EDIT_CLIENT_REQUIREMENTS"] = "edit client requirements";
  TrackingEventContext["EDIT_DEAL_SUMMARY"] = "edit deal summary";
  TrackingEventContext["EDIT_DOCUMENT"] = "edit document";
  TrackingEventContext["EDIT_FOLDER"] = "edit folder";
  TrackingEventContext["EXECUTE_DEAL"] = "execute deal";
  TrackingEventContext["FILTER_PILL"] = "filter pill";
  TrackingEventContext["LEASE_DETAILS"] = "lease details";
  TrackingEventContext["LIKED_LISTING"] = "liked listing";
  TrackingEventContext["LISTING_CARD"] = "listing card";
  TrackingEventContext["LISTING_DETAILS"] = "listing details";
  TrackingEventContext["NEW_DOCUMENT"] = "new document";
  TrackingEventContext["NEW_FOLDER"] = "new folder";
  TrackingEventContext["LISTING_ON_MAP"] = "listing on map";
  TrackingEventContext["NEW_LISTING_THUMBNAIL"] = "new listing thumbnail";
  TrackingEventContext["MAP_LISTING_DETAILS"] = "map listing details";
  TrackingEventContext["MARK_DEAL_AS_LOST"] = "mark deal as lost";
  TrackingEventContext["MOVE_TO_PURSUITS"] = "move to pursuits";
  TrackingEventContext["OPEN_EMAILER"] = "open emailer";
  TrackingEventContext["PAST_TOUR"] = "past tour";
  TrackingEventContext["RESET_DEALROOM"] = "reset dealroom";
  TrackingEventContext["REVERSE_SORT_LISTINGS"] = "reverse sort listings";
  TrackingEventContext["SAVE_DEAL"] = "save deal";
  TrackingEventContext["SAVE_CLIENT_REQUIREMENTS"] = "save client requirements";
  TrackingEventContext["SAVE_DEAL_SUMMARY"] = "save deal summary";
  TrackingEventContext["SAVE_EXPENSES"] = "save expenses";
  TrackingEventContext["SAVE_FILTER"] = "save filter";
  TrackingEventContext["SEND_EMAIL"] = "send email";
  TrackingEventContext["SEND_NUDGE"] = "send nudge";
  TrackingEventContext["SHARE_BUTTON"] = "share button";
  TrackingEventContext["SHOW_MAP_BUTTON"] = "show map button";
  TrackingEventContext["SORT_LEASE"] = "sort lease";
  TrackingEventContext["SORT_LISTINGS"] = "sort listings";
  TrackingEventContext["TOUR_DETAILS"] = "tour details";
  TrackingEventContext["TOUR_REQUESTED"] = "tour requested";
  TrackingEventContext["UPCOMING_TOUR"] = "upcoming tour";
  TrackingEventContext["VIEW_ALL_CRITICAL_DATES"] = "view all critical dates";
  TrackingEventContext["VIEW_ALL"] = "view all";
  TrackingEventContext["VIEW_LEASE"] = "view lease";
  TrackingEventContext["VIEW_LEASES"] = "view leases";
  TrackingEventContext["VIEW_LISTINGS"] = "view listings";
  TrackingEventContext["VIEW_PROPOSAL"] = "view proposal";
  return TrackingEventContext;
}({});

// Deprecated, remove once all tracking is removed
export var TrackingEventTypes = /*#__PURE__*/function (TrackingEventTypes) {
  TrackingEventTypes["BUTTON_PRESS"] = "button_press";
  TrackingEventTypes["DEALROOM_ACTION"] = "dealroom_action";
  TrackingEventTypes["FEATURE_TOGGLE"] = "feature_toggle";
  return TrackingEventTypes;
}({});

// Deprecated, remove once all tracking is removed
export var Context = /*#__PURE__*/function (Context) {
  Context["ACTIVE_DEAL_LISTINGS"] = "active_deal_listings";
  Context["ACTIVE_DEAL_OVERVIEW"] = "active_deal_overview";
  return Context;
}({});